<template>
  <b-modal
    :visible="visible"
    title="Update Resume"
    size="sm"
    centered
    ok-title="Update"
    ok-variant="primary"
    cancel-title="Cancel"
    :ok-disabled="!file || uploading"
    :busy="uploading"
    @change="onVisibility"
    @ok.prevent="onSubmit"
  >
    <p class="mb-1">
      <span class="text-muted">Current file: </span>
      <span>{{ currentFileName || 'No resume on file' }}</span>
    </p>
    <b-form-group label="Resume" label-for="update-resume-file" class="mb-0">
      <b-form-file
        id="update-resume-file"
        v-model="file"
        :accept="resumeAccept"
        placeholder="Browse…"
        drop-placeholder="Drop file here…"
        :disabled="uploading"
      />
    </b-form-group>
    <small v-if="fileError" class="text-danger d-block mt-50">{{ fileError }}</small>
  </b-modal>
</template>

<script>
import { BModal, BFormGroup, BFormFile } from 'bootstrap-vue'
import {
  RESUME_ACCEPT,
  validateResumeFile,
  resumeFileNameFromPath,
} from '@/utils/upload-candidate-resume'

export default {
  name: 'UpdateResumeModal',
  components: { BModal, BFormGroup, BFormFile },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    candidate: {
      type: Object,
      default: null,
    },
    uploading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      resumeAccept: RESUME_ACCEPT,
      file: null,
      fileError: '',
    }
  },
  computed: {
    currentFileName() {
      const path = this.candidate && (this.candidate.cv_path || this.candidate.cv)
      return resumeFileNameFromPath(path)
    },
  },
  watch: {
    visible(open) {
      if (open) {
        this.file = null
        this.fileError = ''
      }
    },
    file(next) {
      this.fileError = next ? (validateResumeFile(next) || '') : ''
    },
  },
  methods: {
    onVisibility(next) {
      this.$emit('update:visible', next)
    },
    onSubmit() {
      if (!this.file || this.uploading) return
      const invalid = validateResumeFile(this.file)
      if (invalid) {
        this.fileError = invalid
        return
      }
      this.$emit('submit', this.file)
    },
  },
}
</script>
